import { Navigate } from "react-router-dom";
import { Center, Loader } from "@mantine/core";
import { useAuth } from "@/auth";

export default function RootRedirect() {
  const { loading, isAuthenticated } = useAuth();
  if (loading) {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }
  return <Navigate to={isAuthenticated ? "/app/home" : "/auth/login"} replace />;
}
